// extracted by mini-css-extract-plugin
module.exports = {"container":"hit-product-list_container__9IVnK","brandCardWrapper":"hit-product-list_brandCardWrapper__6nkXK","fade-in":"hit-product-list_fade-in__E_LW_"};